// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 30px;
}

.skl-card {
  margin-bottom: 20px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__header {
  padding: 16px 20px;
  border-bottom: 1px solid #edf0f2;
}

.skl-card__body {
  padding: 20px;
}

.skl-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
}

@media (max-width: 767.98px) {
  .skl-header {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/modernization-readiness/job-logs-skeleton/job-logs-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;AACF","sourcesContent":[".skl-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 30px;\n}\n\n.skl-card {\n  margin-bottom: 20px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #edf0f2;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 15px;\n}\n\n@media (max-width: 767.98px) {\n  .skl-header {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
